import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  FeatureCheckboxSelected,
  FeatureCheckboxUnselected,
  InfoIcon,
  PriceIcon,
} from '../../../shared/svg/components';
import { changeIsDescriptionOpened } from '../../../model/configuratorSlice';
import { getFeaturePriceText } from '../../../utils/currencyFormatter';
import IsNullOrUndefined from '../../../utils/ObjectUtils';

const FeatureItem = ({
  feature,
  categoryId,
  categoryType,
  isSelected,
  disabled,
  onFeatureSelected,
}) => {
  const { settings, userLoggedIn, currentUnit } = useSelector(state => state.configurator);

  const dispatch = useDispatch();

  return (
    <div className="feature-item">
      <div className="feature-title-container">
        <div className="feature-title">Opción {feature.order}</div>
        {feature.description !== null && feature.description.length > 0 && (
          <button
            className="info-button"
            type="button"
            onClick={() => dispatch(changeIsDescriptionOpened({ isOpen: true, featureId: feature.id, categoryId }))}
          >
            <InfoIcon className="icon" />
          </button>
          )}
        <div className="price">{getFeaturePriceText(feature, currentUnit)}</div>
      </div>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onFeatureSelected((feature.id))}
        className="feature-thumb"
      >
        <div className="image-mask">
          <div className="image-container">
            <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
          </div>
          {isSelected
                ? <FeatureCheckboxSelected className="check" />
                : <FeatureCheckboxUnselected className="check" />}
        </div>
      </button>
      {/* TODO: Use for debugging <div className="feature-name">{`${feature.name}=>${feature.id}`}</div> */}
      {/* <div className="feature-name">{`${feature.name}=>${feature.id}`}</div> */}
      <div className="feature-name">{feature.name}</div>
      <div className="feature-name">
        {/* eslint-disable-next-line max-len */}
        {/* !IsNullOrUndefined(feature.availableIf) || !IsNullOrUndefined(feature.incompatibleWith) ? `Feature blocked: ${feature.availableIf} incompatible: ${feature.incompatibleWith} ` : null */}
      </div>
      {/* <div className="feature-name">{`${feature.name}`}</div> */}
    </div>
  );
};

FeatureItem.propTypes = {
  feature: (PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    thumb: PropTypes.string,
    order: PropTypes.number,
    price: PropTypes.string,
    availableIf: PropTypes.string,
    incompatibleWith: PropTypes.string,
  })).isRequired,
  categoryId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  categoryType: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onFeatureSelected: PropTypes.func.isRequired,
};

export default FeatureItem;
